import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";
import { spError } from "@eventr/common";
import { ColoursObj, Typography } from "@eventr/common-storybook";
import { TypographyProps } from "@mui/material";
import { useLongPress } from "use-long-press";
import i18n from "i18n/i18next";
import { defaultAddSnack } from "state/overlayState/overlayContext";
import { useObjectContext } from "../providers/objectProvider";
import { MarkdownRow } from "home/components/summary/markdownRow";

export interface ICardTextProps extends TypographyProps {
  useMarkdown?: boolean;
  variant?: any;
}

export const CardText = (props: ICardTextProps) => {
  const { past } = useObjectContext();
  const { useMarkdown, variant, ...rest } = props;
  const longpressBind = useLongPress(
    async () => {
      if (rest.children && rest.children !== "") {
        try {
          if (Capacitor.isNativePlatform()) {
            Clipboard.write({
              string: String(rest.children),
            });
            if (Capacitor.getPlatform() === "ios") {
              if (Capacitor.getPlatform() === "ios") {
                defaultAddSnack(i18n.t("snack.copied-clipboard"), "success");
              } else {
                /// android....
              }
            } else {
              /// android....
            }
          } else {
            if (navigator.clipboard) {
              await navigator.clipboard.writeText(String(props.children));
            } else {
              defaultAddSnack(i18n.t("snack.not-secure-context"), "error");
            }
          }
        } catch (error) {
          spError(error);
        }
      }
    },
    {
      threshold: 700, // In milliseconds
    },
  );
  if (useMarkdown) {
    if (!rest.children || rest.children === "") return <Typography />;
    return <MarkdownRow past={past} value={String(rest.children)} />;
  }

  return (
    <Typography
      id="cardText"
      color={past ? ColoursObj.shades.shade2 : ColoursObj.font.primary}
      variant={variant}
      {...(longpressBind() as React.HTMLAttributes<HTMLElement>)}
      {...rest}
    >
      {rest.children}
    </Typography>
  );
};
